export enum SaveSaleFormFields {
  Name = 'name',
  Url = 'url',
  Phone = 'phone',
  Logo = 'logo',
  WorkingHours = 'workingHours',
}

export const SaveSaleFormFieldsList = Object.values(SaveSaleFormFields);
